var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn_wrap_right"},[_vm._t("pageSize",null,{"id":"pageSize"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }